import axios from 'axios';

// API base URL - uses relative path in production with custom domains
const configuredUrl = process.env.REACT_APP_BACKEND_URL || '';

function getApiBase() {
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    if (configuredUrl && currentOrigin === configuredUrl) {
      return `${configuredUrl}/api`;
    }
    if (configuredUrl && !currentOrigin.includes('localhost')) {
      return `${currentOrigin}/api`;
    }
  }
  return `${configuredUrl}/api`;
}

export const API = getApiBase();
export const BACKEND_URL = typeof window !== 'undefined' ? window.location.origin : configuredUrl;

// Global axios interceptor - ALWAYS attach token from localStorage
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('plazafy_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global response interceptor - clear stale tokens on 401
// This handles tokens issued by older (buggy) backend versions that
// can no longer be decoded after backend fixes.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = !!localStorage.getItem('plazafy_token');
      if (hadToken) {
        localStorage.removeItem('plazafy_token');
        localStorage.removeItem('plazafy_user');
        delete axios.defaults.headers.common['Authorization'];
        // Avoid redirect loops if already on /login or callback pages
        const path = typeof window !== 'undefined' ? window.location.pathname : '';
        const safePaths = ['/login', '/register', '/auth/callback', '/auth/apple/callback', '/'];
        if (!safePaths.some(p => path === p || path.startsWith(p))) {
          window.location.href = '/login?session_expired=1';
        }
      }
    }
    return Promise.reject(error);
  }
);
